const init = {
  feedback: [],
  feedbackLoading: true,
  pendingFeedback: [],
};

const dataReducer = (state = { ...init }, action) => {
  switch (action.type) {
    case 'SET_FEEDBACK':
      return {
        ...state,
        feedback: action.feedback,
      };
    case 'SET_FEEDBACK_LOADING':
      return {
        ...state,
        feedbackLoading: action.feedbackLoading,
      };
    case 'SET_PENDING_FEEDBACK':
      return {
        ...state,
        pendingFeedback: action.pendingFeedback,
      };

    default:
      return state;
  }
};

export default dataReducer;
